import React from "react";
import ControlSection from "./ControlSection";

/**
 * Background settings component with show/hide toggle and color picker
 */
const BackgroundSettings = ({
  showBackground,
  backgroundColor,
  onShowBackgroundChange,
  onColorChange,
}) => {
  return (
    <ControlSection>
      <label style={{ display: "block", marginBottom: "4px" }}>
        Show Text Box Background?
      </label>
      <div
        style={{
          display: "flex",
          gap: "16px",
          alignItems: "center",
        }}
      >
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <input
            type="radio"
            name="showBackground"
            checked={showBackground === true}
            onChange={() => onShowBackgroundChange(true)}
          />
          Yes
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <input
            type="radio"
            name="showBackground"
            checked={showBackground === false}
            onChange={() => onShowBackgroundChange(false)}
          />
          No
        </label>

        {showBackground === true && (
          <input
            type="color"
            value={backgroundColor || "#ffffff"}
            onChange={(e) => onColorChange(e.target.value)}
            style={{
              width: "60px",
              height: "30px",
              padding: "0",
              border: "1px solid #ccc",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          />
        )}
      </div>
    </ControlSection>
  );
};

export default BackgroundSettings;
